module.exports = __webpack_public_path__ + "media/images/procedure_managements/what_is/img_mobile_2-84f17ae7688111eb0d0f1958e0adfbc2.png";